import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { User, IProfile, IMetaData, ISlipsFormData } from '../models/index';

@Injectable()
export class StateService {
  private readonly userKey: string = 'currentUser';
  private readonly metaDataKey: string = 'metaData';
  private readonly resetToken: string = 'resetToken';
  private readonly rememberMe: string = 'rememberMe';
  public sidemenuSubject = new Subject<string>();
  private readonly currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public summarySubject = new BehaviorSubject<boolean>(false);

  private readonly profieDetailsSubject: BehaviorSubject<IProfile>;
  private readonly provincialsDetailsSubject: BehaviorSubject<IProfile>;
  public profileDetails: Observable<IProfile>;
  public provincialsDetails: Observable<any>;

  private readonly currentItrSubject: BehaviorSubject<number>;
  public currentItr: Observable<number>;
  public slipFormData: ISlipsFormData;
  public isUpdateLog = new BehaviorSubject(null);
  private readonly logoutClickedSubject: BehaviorSubject<boolean>;

  constructor() {
    this.currentUserSubject = new BehaviorSubject<User>(this.getUser());
    this.currentUser = this.currentUserSubject.asObservable();

    this.profieDetailsSubject = new BehaviorSubject<IProfile>({} as IProfile);
    this.profileDetails = this.profieDetailsSubject.asObservable();

    this.provincialsDetailsSubject = new BehaviorSubject<IProfile>({} as any);
    this.provincialsDetails = this.provincialsDetailsSubject.asObservable();

    this.currentItrSubject = new BehaviorSubject<number>(0);
    this.currentItr = this.currentItrSubject.asObservable();

    this.logoutClickedSubject = new BehaviorSubject<boolean>(false);

    this.slipFormData = this.initSlipFormData();
  }

  public onAppLoad(): void {
    const currentLoggedInUser = this.getUser();
    this.currentUserSubject.next(currentLoggedInUser);
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get currentProfileDetails(): IProfile {
    return this.profieDetailsSubject.value;
  }

  public get savedProvincialsDetails(): any {
    return this.provincialsDetailsSubject.value;
  }

  public get isLogoutClicked(): boolean {
    return this.logoutClickedSubject.value;
  }

  public setCurrentUser(user: User, isLongTerm: boolean): void {
    this.currentUserSubject.next(user);

    const json = JSON.stringify(user);

    if (isLongTerm) {
      localStorage.setItem(this.userKey, json);
    } else {
      sessionStorage.setItem(this.userKey, json);
    }
  }

  public setProfileDetails(profile: IProfile): void {
    this.profieDetailsSubject.next(profile);
  }

  public setProvincialsDetails(provincials): void {
    this.provincialsDetailsSubject.next(provincials);
  }

  public setCurrentItr(itr: number): void {
    this.currentItrSubject.next(itr);
  }

  public getCurrentItr(itr: number): number {
    return this.currentItrSubject.value;
  }

  public setMetadata(metaData: IMetaData): void {
    const jsonData = JSON.stringify(metaData);
    localStorage.setItem(this.metaDataKey, jsonData);
  }

  public getMetaData(): IMetaData {
    const metaData = localStorage.getItem(this.metaDataKey);
    return JSON.parse(metaData);
  }
  public setResetPasswordToken(token: string): void {
    localStorage.setItem(this.resetToken, token);
  }
  public getResetPasswordToken(): string {
    return localStorage.getItem(this.resetToken);
  }
  public removeResetPasswordToken(): void {
    localStorage.removeItem(this.resetToken);
  }

  public setRememberMeEmail(email: string): void {
    localStorage.setItem(this.rememberMe, email);
  }
  public getRememberMeEmail(): string {
    return localStorage.getItem(this.rememberMe);
  }

  public removeRememberMeEmail(): void {
    localStorage.removeItem(this.rememberMe);
  }

  public getUser(): User {
    let storedUser: any = localStorage.getItem(this.userKey);

    if (storedUser == null) {
      storedUser = sessionStorage.getItem(this.userKey);
    }

    if (storedUser == null) {
      return null;
    }

    const json: any = JSON.parse(storedUser);
    const user: User = new User(json);

    return user;
  }
  public removeUser(): void {
    localStorage.removeItem(this.userKey);
    sessionStorage.removeItem(this.userKey);
  }
  private initSlipFormData(): ISlipsFormData {
    return {
      income: [],
      rrsp: [],
      deduction: [],
    };
  }
  public setSlipFormData(slipType, slipFormData): void {
    this.slipFormData[slipType] = slipFormData;
  }

  public setLogoutClicked(flag = false): void {
    this.logoutClickedSubject.next(flag);
  }

  public sidebarMenuDisplay(data): void {
    // passing the data as the next observable
    this.sidemenuSubject.next(data);
  }
  public summaryLoadValue(flag = false): void {
    this.summarySubject.next(flag);
  }
}
